<!-- 首页//用能趋势分析  -->
<template>
    <div class="box">
      <Title :text="electricity.Ranking.Title[0]" :engText="electricity.Ranking.Title[1]"></Title>
       <div class="content">
        <div class="content-title">
          <div class="a1">
            [
            <div :class="`${active === 1 ? 'active' : ''}`" @click="fn1(1)">剩余电流越限次数</div>
            <div :class="`${active === 2 ? 'active' : ''}`" @click="fn1(2)">接近越限次数</div>
            ]
          </div>
        </div>
        <div class="echarts-content">
            <chart-block ref="chart"></chart-block>
        </div>
      </div>
      <div class="data">
        <div class="li">
            <div>
                <div class="blue1"></div>
                <div class="text">消防水泵房</div>
            </div>
            <div class="val c-white">{{electricity.Ranking.data1[active-1].xf}}次</div>
        </div>
        <div class="li">
            <div>
                <div class="blue2"></div>
                <div class="text">海关查验库</div>
            </div>
            <div class="val c-white">{{electricity.Ranking.data1[active-1].hg}}次</div>
        </div>
        <div class="li">
            <div>
                <div class="green"></div>
                <div class="text">设备用房</div>
            </div>
            <div class="val c-white">{{electricity.Ranking.data1[active-1].sb}}次</div>
        </div>
        <div class="li">
            <div>
                <div class="yellow"></div>
                <div class="text">检查大厅</div>
            </div>
            <div class="val c-white">{{electricity.Ranking.data1[active-1].jc}}次</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Title from '../../components/title/index.vue';
  import { mapState,mapActions } from 'pinia' //引入映射函数
  import useStore from '@/store/index' //引入store
  export default {
    components: {
      Title,
    },
    computed:{
      ...mapState(useStore,['electricity']) 
    },
   data () {
      return {
        // active 1:日，2:月，3:年
        active:1,
      }
    },
    mounted () {
      this.$refs.chart.setOption(this.electricity.Ranking.data2[this.active-1]);
    },
    methods: {
      fn1(i){
        this.active = i;
        console.log(i);
        this.$refs.chart.setOption(this.electricity.Ranking.data2[i-1]);
      }
    }
  }
  </script>
  
  <style scoped>
  .box{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .content{
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .content-title{
    width: 100%;
    height: 24px;
    display: flex;
    flex-direction: column;
  }
  .content-title .a1{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-title .a1 > div{
    margin: 0px 10px;
    font-size: 12px;
    cursor: pointer;
  }
  .active{
    text-shadow: 0px 4px 5px #488dff;
  }
  .data {
    width: 100%;
    height: 54px;
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .data .li{
    width: 120px;
    justify-content: space-between;
    display: flex;
    align-items: center;
    
  }
  .data .li >div{
        /* width: 100%; */
        display: flex;
    /* justify-content: space-between; */
    align-items: center;

  }
  .blue1{
    background: #36ddff;
    width: 10px;
    height: 10px;
    margin-right: 5px;
  }
  .blue2{
    background: #2275ff;
    width: 10px;
    height: 10px;
    margin-right: 5px;

  }
  .green{
    background: #36ffc4;
    width: 10px;
    height: 10px;
    margin-right: 5px;

  }
  .yellow{
    background: #ffb400;
    width: 10px;
    height: 10px;
    margin-right: 5px;

  }
  .c-white{
    color: white;
  }
  </style>